import styled from '@emotion/styled'

export const StyleNoteWrapper = styled.div`
  border-radius: 8px;
  background: ${(props: any) => props.theme.colors.primary50};
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  margin-bottom: 20px;
`
export const styleButton = ` 
margin-left:auto;
min-width:150px`
